import { render, staticRenderFns } from "./TabNav.vue?vue&type=template&id=212a5a10&scoped=true&"
import script from "./TabNav.vue?vue&type=script&lang=js&"
export * from "./TabNav.vue?vue&type=script&lang=js&"
import style0 from "./TabNav.vue?vue&type=style&index=0&id=212a5a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212a5a10",
  null
  
)

export default component.exports